/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { Oas20Response } from '../../openapi/v2/models/Oas20Response';
import { SetExampleCommand } from './SetExampleCommand';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { Oas20Example } from '../../openapi/v2/models/Oas20Example';

/**
 * @author eric.wittmann@gmail.com
 * @extends SetExampleCommand
 * @class
 */
export class SetExampleCommand_20 extends SetExampleCommand {
    public _newContentType : string;

    public _nullExamples : boolean;

    public constructor(parent? : any, example? : any, contentType? : any) {
        if(((parent != null && parent instanceof <any>Oas20Response) || parent === null) && ((example != null) || example === null) && ((typeof contentType === 'string') || contentType === null)) {
            let __args = arguments;
            super(parent, example);
            if(this._newContentType===undefined) this._newContentType = null;
            if(this._nullExamples===undefined) this._nullExamples = false;
            if(this._newContentType===undefined) this._newContentType = null;
            if(this._nullExamples===undefined) this._nullExamples = false;
            (() => {
                this._newContentType = contentType;
            })();
        } else if(parent === undefined && example === undefined && contentType === undefined) {
            let __args = arguments;
            super();
            if(this._newContentType===undefined) this._newContentType = null;
            if(this._nullExamples===undefined) this._nullExamples = false;
            if(this._newContentType===undefined) this._newContentType = null;
            if(this._nullExamples===undefined) this._nullExamples = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[SetExampleCommand_20] Executing.");
        this._oldValue = null;
        let response : Oas20Response = <Oas20Response>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(response)) {
            return;
        }
        if(this.isNullOrUndefined(response.examples)) {
            response.examples = response.createExample();
            this._nullExamples = true;
        }
        this._oldValue = response.examples.getExample(this._newContentType);
        response.examples.addExample(this._newContentType, this._newExample);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[SetExampleCommand_20] Reverting.");
        let response : Oas20Response = <Oas20Response>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(response)) {
            return;
        }
        if(this.isNullOrUndefined(response.examples)) {
            return;
        }
        if(this._nullExamples) {
            response.examples = null;
            return;
        }
        if(this.isNullOrUndefined(this._oldValue)) {
            response.examples.removeExample(this._newContentType);
        } else {
            response.examples.addExample(this._newContentType, this._oldValue);
        }
    }
}
SetExampleCommand_20["__class"] = "io.apicurio.datamodels.cmd.commands.SetExampleCommand_20";
SetExampleCommand_20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




